export default __webpack_public_path__ + "static/media/Generator.787e99cf.gif";